import React from "react";

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <div className="a11y-toggle-row">
      <span className="a11y-toggle-label">{label}</span>

      <button
        type="button"
        className={`a11y-switch ${checked ? "active" : ""}`}
        onClick={() => onChange(!checked)}
        aria-pressed={checked}
        role="switch"
      >
        <span className="a11y-switch-thumb" />
      </button>
    </div>
  );
};

export default ToggleSwitch;
